"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBundleAPIResponseError = exports.ManageBundleBlank = exports.ManageBundleRequestDTOSchema = exports.ManageBundleDTO = exports.ManageBundleSchema = exports.ManageBundleBaseSchema = void 0;
var zod_1 = require("zod");
var CommonMongoModelFields_1 = require("./lib/CommonMongoModelFields");
var ObjectId_1 = require("./lib/ObjectId");
exports.ManageBundleBaseSchema = zod_1.z.object({
    userId: zod_1.z.instanceof(ObjectId_1.ObjectId),
    tokensAvailable: zod_1.z.number(),
    invoiceId: zod_1.z.string(),
    stripeSession: zod_1.z.any().optional(),
    bundlePlanId: zod_1.z.instanceof(ObjectId_1.ObjectId).optional(),
});
exports.ManageBundleSchema = exports.ManageBundleBaseSchema.extend(CommonMongoModelFields_1.CommonModelDTOFields);
var ManageBundleDTOSchema = exports.ManageBundleSchema.extend(CommonMongoModelFields_1.CommonModelRequestDTOFields);
exports.ManageBundleDTO = {
    converFromModel: function (model) {
        var dto = {
            _id: model._id.toString(),
            createdAt: model.createdAt,
            updatedAt: model.updatedAt,
            userId: model.userId,
            tokensAvailable: model.tokensAvailable,
            invoiceId: model.invoiceId,
        };
        // Extraer información del stripeSession si existe
        if (model.stripeSession) {
            dto.amountPaid = model.stripeSession.amount_total ? model.stripeSession.amount_total / 100 : undefined;
            dto.currency = model.stripeSession.currency;
            dto.paymentDate = model.stripeSession.created ? new Date(model.stripeSession.created * 1000) : undefined;
            dto.paymentMethods = model.stripeSession.payment_method_types;
            dto.paymentStatus = model.stripeSession.payment_status;
        }
        return dto;
    },
};
exports.ManageBundleRequestDTOSchema = ManageBundleDTOSchema.extend(CommonMongoModelFields_1.CommonMongoModelFields);
exports.ManageBundleBlank = {
    _id: new ObjectId_1.ObjectId(),
    createdAt: new Date(),
    userId: new ObjectId_1.ObjectId(),
    tokensAvailable: 0,
    invoiceId: '',
    updatedAt: new Date(),
};
var isBundleAPIResponseError = function (response) {
    return 'message' in response;
};
exports.isBundleAPIResponseError = isBundleAPIResponseError;
//# sourceMappingURL=Bundle.js.map